import { render, staticRenderFns } from "./AfterSales.vue?vue&type=template&id=f7f4b738&scoped=true"
import script from "./AfterSales.vue?vue&type=script&lang=js"
export * from "./AfterSales.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./AfterSales.vue?vue&type=style&index=0&id=f7f4b738&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./AfterSales.vue?vue&type=style&index=1&id=f7f4b738&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f7f4b738",
  "f4c4177c"
  
)

export default component.exports